import Axios from "@/plugins/Axios";

export class FeedbackCoordenacaoService {
  async listAll(query = null) {
    const response = await Axios().get("feedback-coordenacao", { params: { query } });

    return response.data;
  }

  async buscarMatriculas(query = null) {
    const response = await Axios().get("feedback-coordenacao/matriculas", { params: { query } });

    return response.data;
  }

  async criar(payload) {
    const response = await Axios().post("feedback-coordenacao", payload);

    return response.data;
  }

  async atualizar(id, payload) {
    const response = await Axios().put(`feedback-coordenacao/${id}`, payload);

    return response.data;
  }

  async deletar(feedback) {
    const response = await Axios().delete(`feedback-coordenacao/${feedback.id}`);

    return response.data;
  }
}

export default new FeedbackCoordenacaoService();
